import VueRouter from 'vue-router';
import routes from './routes';
//  const fb = require('../../Firebase.js');
import fb from '../Firebase';

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach( (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  var currentUser =   false;
  fb.auth().onAuthStateChanged(function(user) {
    if (user) {
      currentUser = true;
     // console.log("yes");
      if (requiresAuth && !currentUser) next({ path: '/login' })//, query: { redirect: to.fullPath } 
      else if (!requiresAuth && currentUser) next('/')
       else if (!requiresAuth && !currentUser) next()
       else next()
    } else {
    //  console.log("no");
      currentUser = false;
      if (requiresAuth && !currentUser) next({ path: '/login' })//, query: { redirect: to.fullPath } 
      else if (!requiresAuth && currentUser) next('/')
       else if (!requiresAuth && !currentUser) next()
       else next()
    }
  });

  // const currentUser =   fb.auth().currentUser;
  
  // console.log("route");
  // console.log(currentUser);
  
  // console.log(to);
  //  console.log(from);

  // console.log("re:"+requiresAuth);

  

 
});

export default router;
